import Image from 'next/image';

import { SubHeadline, Text } from '~components/Typography';
import { useTranslations } from '~i18n/hooks';
import { ButtonGhost } from '~shared/ui/atoms/Buttons/ButtonGhost';

import type { TToast } from '../../types';
import { Flame, Flex, Level, Neuron, Wrapper } from './styles';

export const Toast = ({
	title = '',
	text = '',
	titleKey,
	textKey,
	onUndo,
}: TToast) => {
	const t = useTranslations('Toaster');

	const titleStr = titleKey ? t(titleKey) : title;
	const textStr = textKey ? t(textKey) : text;

	return (
		<Wrapper>
			<Flex>
				<Text size="L" align="left">
					{titleStr}
				</Text>
				{typeof onUndo === 'function' && (
					<ButtonGhost onClick={onUndo}>{t('abortButton')}</ButtonGhost>
				)}
			</Flex>
			<Text size="L" align="left" color="semi-transparent">
				{textStr}
			</Text>
		</Wrapper>
	);
};

export const LevelToast = ({ level }: { level: number }) => {
	const t = useTranslations('Toaster');

	return (
		<>
			<Level
				data-level={level}
				className="BagelToast__level"
				data-smalltext={level > 99}
			/>
			<Wrapper>
				<SubHeadline size="L" align="left">
					{t('reachedLevelTitle')}
				</SubHeadline>
				<Text size="M" align="left" color="semi-transparent">
					{t('reachedLevelMessage', {
						level,
					})}
				</Text>
			</Wrapper>
		</>
	);
};

export const NeuronsToast = ({ amount }: { amount: string }) => {
	const t = useTranslations('Toaster');

	return (
		<>
			<Neuron className="BagelToast__neuron">
				<Image
					width={52}
					height={52}
					src="/img/neurons/gem-icon.png"
					alt="neuron image"
					quality={100}
				/>
			</Neuron>
			<Wrapper>
				<SubHeadline size="L" align="left">
					{t('neuronsAddedTitle')}
				</SubHeadline>
				<Text size="M" align="left" color="semi-transparent">
					{t('neuronsAddedMessage', {
						amount,
					})}
				</Text>
			</Wrapper>
		</>
	);
};

export const DemoGenerationToast = ({ amount }: { amount: string }) => {
	const t = useTranslations('Toaster');

	return (
		<>
			<Flame>
				<Image
					src="/img/gtool/flame.gif"
					width={40}
					height={40}
					quality={85}
					unoptimized={true}
					alt="flame image"
				/>
			</Flame>
			<Wrapper>
				<SubHeadline size="L" align="left">
					{t('freeGenerationsTitle')}
				</SubHeadline>
				<Text size="M" align="left" color="semi-transparent">
					{t('freeGenerationsMessage', {
						amount,
					})}
				</Text>
			</Wrapper>
		</>
	);
};
